"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BN_ZERO = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
exports.BN_ZERO = new bn_js_1.default(0);
//# sourceMappingURL=numbers.js.map